import {formMessageError} from "../message/formMessage";


export function checkNameValid() {
    if (this.value == '') {
        this.setCustomValidity(formMessageError.name.empty);
    }
    else if(this.validity.tooShort){
        this.setCustomValidity(formMessageError.name.minlength);
    }
    else {
        this.setCustomValidity('');
    }
    return true;
}
